export class DynamicFormConfigCreateOptions {
  readonly: boolean = false;
  constructor() {}
}
